(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fatio-first-order-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('FatioSignupPopup');
    if (!popup) return;

    const storageKey = 'fatio_first_order_popup_seen_v1';
    const isSuccess = Boolean(popup.querySelector('[data-popup-success]'));
    if (isSuccess) popup.classList.add('fatio-signup--submitted');
    const open = () => {
      popup.hidden = false;
      document.body.classList.add('fatio-popup-open');
      popup.querySelector('input, [data-copy-code]')?.focus();
    };
    const close = () => {
      popup.hidden = true;
      document.body.classList.remove('fatio-popup-open');
      try { localStorage.setItem(storageKey, Date.now().toString()); } catch (error) {}
    };

    popup.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) close();
    });

    const form = popup.querySelector('form');
    form?.addEventListener('submit', () => {
      const selected = [...popup.querySelectorAll('.fatio-signup__interests input:checked')].map((input) => input.value);
      const tags = ['Fatio popup signup', ...selected.map((value) => `Interest: ${value}`)];
      popup.querySelector('[data-interest-tags]').value = tags.join(', ');
      try { localStorage.setItem(storageKey, Date.now().toString()); } catch (error) {}
    });

    popup.querySelector('[data-copy-code]')?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText('FIRST10');
        popup.querySelector('[data-copy-status]').textContent = 'Copied';
      } catch (error) {
        popup.querySelector('[data-copy-status]').textContent = 'Code: FIRST10';
      }
    });

    if (isSuccess) {
      open();
      return;
    }

    let seen = false;
    try { seen = Boolean(localStorage.getItem(storageKey)); } catch (error) {}
    if (!seen && !window.Shopify?.designMode) window.setTimeout(open, Number(popup.dataset.delay) || 10000);
    if (window.Shopify?.designMode) open();
  })();
  } catch(e) { console.error(e); }
})();

})();
